import type { PumPreview, PumJumpSrpData } from '../types';

export interface SearchResultService {
    getPumPreviewParams(data: PumPreview): Promise<PumJumpSrpData>;
}

export const SearchResultService = Symbol('SearchResultService');
